import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service'; 
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  constructor(private apiService: ApiService, private router: Router) {}

  isAuthenticated(): boolean {
    const token = sessionStorage.getItem('access_token');
    if (!token) {
      return false;
    }
  
    const tokenExpiry = this.decodeTokenExpiry(token);
    
    if (tokenExpiry < Date.now()) {
      this.clearData();
      return false;
    }

    return true;
  }

  private decodeTokenExpiry(token: string): number {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  }

  clearData(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);

    this.apiService.getRequest('logout').subscribe({
      next: (item) => {
        if (item.status) {
          console.warn('Session logout successful');
        } else {
          console.error('Something went wrong during logout');
        }
      },
      error: (err) => {
        console.error('Logout request failed:', err);
      }
    });
  }
}
